import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/Login'
import Home from '@/pages/Home'

import Welcome from '@/pages/op/Welcome'

import User from '@/pages/op/user/User'
import Agent from '@/pages/op/user/Agent'

import StoreApp from '@/pages/op/store/StoreApp'
import AppExtend from '@/pages/op/store/AppExtend'
import UserApp from '@/pages/op/store/UserApp'
import AgentApp from '@/pages/op/store/AgentApp'
import AppCategory from '@/pages/op/store/AppCategory'

import Bill from '@/pages/op/Bill'

import Device from '@/pages/op/Device'

import App from '@/pages/op/app/App'
import Bin from '@/pages/op/app/Bin'

import Factory from '@/pages/op/factory/Factory'
import AdvRegistry from '@/pages/op/factory/AdvRegistry'
import DevTools from '@/pages/op/factory/DevTools'
import CloudLog from '@/pages/op/CloudLog'

import MerchantInfoSupply from '@/pages/op/bank/MerchantInfoSupply'
import SplitAccount from '@/pages/op/bank/SplitAccount'

import OpUser from '@/pages/op/acl/OpUser'
import OpRole from '@/pages/op/acl/OpRole'
import OpResource from '@/pages/op/acl/op_resource'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/op',
      name: 'Home',
      component: Home,
      children: [
        // 欢迎页
        {
          path: 'welcome',
          name: 'Welcome',
          component: Welcome
        },
        // 商户管理
        {
          path: 'user',
          name: 'User',
          component: User
        },
        {
          path: 'agent',
          name: 'Agent',
          component: Agent
        },

        // 套餐管理
        {
          path: 'store/app',
          name: 'StoreApp',
          component: StoreApp
        },
        {
          path: 'store/app_extend',
          name: 'AppExtend',
          component: AppExtend
        },
        {
          path: 'store/user_app',
          name: 'UserApp',
          component: UserApp
        },
        {
          path: 'store/agent_app',
          name: 'AgentApp',
          component: AgentApp
        },
        {
          path: 'store/app_category',
          name: 'AppCategory',
          component: AppCategory
        },

        // 订单管理
        {
          path: 'bill',
          name: 'Bill',
          component: Bill
        },

        // 设备管理
        {
          path: 'dev',
          name: 'Device',
          component: Device
        },

        // 应用管理
        {
          path: 'app',
          name: 'App',
          component: App
        },
        {
          path: 'bin',
          name: 'Bin',
          component: Bin
        },

        // 厂商管理
        {
          path: 'factory',
          name: 'Factory',
          component: Factory
        },
        {
          path: 'adv_registry',
          name: 'AdvRegistry',
          component: AdvRegistry
        },
        {
          path: 'dev_tools',
          name: 'DevTools',
          component: DevTools
        },
        {
          path: 'cloud_log',
          name: 'CloudLog',
          component: CloudLog
        },

        // 资金管理
        {
          path: 'merchant_info_supply',
          name: 'MerchantInfoSupply',
          component: MerchantInfoSupply
        },
        {
          path: 'split_account',
          name: 'SplitAccount',
          component: SplitAccount
        },

        // 权限管理
        {
          path: 'op_user',
          name: 'OpUser',
          component: OpUser
        },
        {
          path: 'op_role',
          name: 'OpRole',
          component: OpRole
        },
        {
          path: 'op_resource',
          name: 'OpResource',
          component: OpResource
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js